import EmetteurtntRepository from '../../../../repositories/emetteurtnt.repository';

require('./emetteurtnt.scss');

export default class EmetteurtntComponent {
  constructor() {
    this.controller = EmetteurtntController;
    this.template = require('./emetteurtnt.html');
    this.bindings = {
      prefix: '@',
      emetteurtnt: '<',
      parentForm: '<',
      onEmetteurtntChange: '&'
    };
  }
}

// @ngInject
class EmetteurtntController {
  constructor() {
    this.emetteurtnts = {
      loading: false,
      data: []
    };
  }

  $onInit() {
    this.prefix = this.prefix ? this.prefix : '';
  }

  $onChanges(changes) {
    if (changes.emetteurtnt) {
      this.data = this.emetteurtnt ? this.emetteurtnt : {emetteurtnt: null};
      if (this.data.emetteurtnt) {
        this.emetteurtnts.data = [this.data.emetteurtnt];
      }
    }
  }

  refreshEmetteurtnts (search) {

    if (!search) {
      return;
    }
    this.emetteurtnts.loading = true;

    return EmetteurtntRepository.searchEmetteurtnt(search)
      .then((response) => {
        this.emetteurtnts.data = response.data;
      })
      .finally(() => this.emetteurtnts.loading = false);
  }

  onEmetteurtntSelect ($item) {
    if ($item) {
      this.emetteurtnts.data = [this.data.emetteurtnt];
    } else {
      this.emetteurtnts.data = [];
      this.data.emetteurtnt = null;
    }
    this.onChange();
  }

  onChange() {
    this.onEmetteurtntChange({emetteurtnt: this.data});
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/emetteurtnt/emetteurtnt.component.js